import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { AuthService } from '../../services/auth.services'
import { RestServices } from '../rest.services'
import { SocketService } from '@app/services/socket.service'

declare var jQuery: any

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router, private restApi: RestServices, private socketService: SocketService) {
        let newVariable: any
        newVariable = window.navigator
        if (('standalone' in newVariable) && !newVariable.standalone) {
            // .... code here ....
            const isSafari = /iPad|iPhone|iPod/.test(navigator.userAgent)
            if (isSafari) {
                this.router.navigateByUrl('/app/login')
            }
        }
        this.getCommon()
    }

    getCommon() {
        // set class display theme
        if(localStorage.getItem('classThemeBody')) {
            jQuery('body').attr('class', localStorage.getItem('classThemeBody'))
        }
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                setting: {
                    map: {
                        common: true,
                    },
                },
            },
        }
        this.authService.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const themeStatus = success['response']['setting']['map']['common']['chooseTheme'] || 'blue'
                if (themeStatus != localStorage.getItem('classThemeBody')) {
                    jQuery('body').attr('class', themeStatus)
                    localStorage.setItem('classThemeBody', themeStatus)
                }
                const checkAddressCommon = success['response']['setting']['map']['common']['address'] || ' '
                const timezone = success['response']['setting']['map']['common']['timezone']
                const countryCode = success['response']['setting']['map']['common']['countryCode']
                if ((!checkAddressCommon || checkAddressCommon === ' ') && (timezone === 'Asia/Tokyo' || timezone === 'Japan' || countryCode === 'JP')) {
                    return this.router.navigateByUrl('/app/main/setting/common')
                }
            })
        })
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {
        if (this.authService.getItem('user')) {
            this.getCommon()
            this.socketService.initSocket()
            return true
        } else {
            this.router.navigateByUrl('/app/login')
            return false
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/guarad/auth.guard.ts